export const getUrlWithoutDomain = (url: string) => {
  try {
    const urlObject = new URL(url);
    return `${urlObject.pathname}${urlObject.search}`;
  } catch (e) {
    return url;
  }
};
